'use client';

import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import type { NavigationItemProps } from '@lichtblick/photon/types/navigationItemProps';
import { useTracker } from '@lichtblick/tracker';
import type { FC } from 'react';

import styles from './Footer.module.scss';

export const PrimarySubNavigation: FC<NavigationItemProps> = ({ href, shouldOpenInNewTab, text, tracking }) => {
  const { trackCustomEvent } = useTracker();

  return (
    <li className={styles['primary-nav-item']}>
      <TextCTA
        as="a"
        href={href}
        onClick={() => trackCustomEvent(tracking)}
        tabIndex={href ? undefined : 0}
        target={shouldOpenInNewTab ? '_blank' : ''}
      >
        {text}
      </TextCTA>
    </li>
  );
};
